import React, { Component } from 'react';
import * as $ from 'jquery';
import axios from 'axios';
import { compose } from 'recompose';
import { Trans, translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import TypeOfCard from '../../../components/TypeOfCard';
import { validateCard } from '../../../helpers/card';
import GoBackButton from '../../../components/GoBackButton';
import SuccessDialogPayment from '../../../components/SuccessDialogPayment';
import Dialog from '../../../components/Dialog';
import Tag from '../../../components/Tag';
import Input from '../../../components/Input';

let cancelToken;

class CardDomicilioConatiner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            center_info: null,
            cardCvc: "",
            cardDate: "",
            cardName: "",
            cardNumber: "",
            cardMonth: "",
            cardYear: "",
            street: "",
            neighborhood: "",
            country: "",
            city: "",
            postalCode: "",
            duracion_str: "",
            precio: 0,
            province: "",
            is_accept_terms: false,
            is_factura: false,
            error: null,
            success: null,
            showModalInvalidNumber: false,
            fieldsValid: {}
        };
    }

    componentDidMount() {
        cancelToken = axios.CancelToken.source();
        const props = this.props.location.state;
        const domicilio_id = this.props.match.params.domicilioid;

        // Si no tenemos el id del domicilio o los props regresamos
        if (!domicilio_id || !props) {
            this.props.history.goBack();
            return null;
        }
        // Verificamos si tenemos los datos del pago 1
        const keys = Object.keys(props);
        console.log(keys)
        if (keys.length < 7) {
            this.props.history.goBack();
            return null;
        }

        this.setState({
            ...props,
            centro_id: domicilio_id
        })
        this.getCenter({
            token_id: this.props.getTokenId(),
            center_id: domicilio_id
        });
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
    }

    getCenter = (params) => {
        this.props.post(
            "/getCentersByCity",
            params,
            (response) => this.setState({ center_info: response }),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getTokenParams = () => {
        const number = this.state.cardNumber.replace(/\s/g, '');
        return {
            card: {
                name: this.state.cardName.trim(),
                number,
                exp_year: "20" + this.state.cardYear.trim(),
                exp_month: this.state.cardMonth.trim(),
                cvc: this.state.cardCvc.trim(),
                address: {
                    street1: this.state.street.trim(),
                    street2: this.state.neighborhood.trim(),
                    city: this.state.city.trim(),
                    state: this.state.province.trim(),
                    zip: this.state.postalCode.trim(),
                    country: this.state.country.trim(),
                },
            },
        };
    }

    handleErrorResponse = (response) => {
        alert('La infomacion del Centro es Incorrecta');
    }

    handleCardName = (event) => {
        this.setState({ cardName: event.target.value });
    }

    handleCardMonth = (event) => {
        this.setState({ cardMonth: event.target.value });
    }


    handleCardNumber = (e) => {
        let value = e.target.value
        const { isValid, newValue } = validateCard({ value, state: this.state.cardNumber })
        if (isValid) {
            this.setState({ cardNumber: newValue });
        }
    }

    handleCardYear = (event) => {
        this.setState({ cardYear: event.target.value });
    }

    handleCardCvc = (event) => {
        this.setState({ cardCvc: event.target.value });
    }
    handleStreetChange = (event) => {
        this.setState({ street: event.target.value });
    }

    handleNeighborhoodChange = (event) => {
        this.setState({ neighborhood: event.target.value });
    }

    handlePoChange = (event) => {
        this.setState({ postalCode: event.target.value });
    }

    handleCityChange = (event) => {
        this.setState({ city: event.target.value });
    }

    handleStateChange = (event) => {
        this.setState({ province: event.target.value });
    }

    handleCountryChange = (event) => {
        this.setState({ country: event.target.value });
    }

    handlePaymentCoworkConekta = (params) => {
        const onSuccess = (token) => this.payDomicilio(
            Object.assign({},
                params,
                { token_conekta: token.id })
        );

        const onError = (error) => this.setState({
            error: error.message_to_purchaser,
            isPaying: false
        });

        window.Conekta.setPublicKey(this.state.center_info.c_key)
        window.Conekta.Token.create(
            this.getTokenParams(),
            (token) => onSuccess(token),
            (error) => onError(error)
        );
    }

    payDomicilio = (params) => {
        this.props.post(
            "/payDomicilio",
            params,
            // Success
            (data) => {
                console.info({ data });
                this.setState({ success: true })
            },
            // Error de api
            () => {
                this.setState({ isPaying: false, success: false, error: "Error al procesar el pago" });
                console.error("Error de API")
                // this.handleErrorResponseConekta(error);
            },
            cancelToken,
            // Error de Conekta
            ({ data }) => this.setState({ isPaying: false, error: data.msg, success: false })
        );
    }

    handleFacturaChange = (event) => {
        if (this.state.is_factura) {
            this.setState({ is_factura: false });
        } else {
            this.setState({ is_factura: true });
            $('#btnFacturas').click()
        }
    }

    handlePaymentSubmit = (event) => {
        event.preventDefault();
        if (this.state.phone.length !== 10) {
            this.setState({ showModalInvalidNumber: true })
            return null
        }

        const isValid = Object.values(this.state.fieldsValid).every((value) => value);
        if (!isValid) return alert('Favor de llenar todos los campos correctamente')

        const params = {
            name: this.state.name,
            lastname: this.state.lastname,
            phone: this.state.phone,
            email: this.state.email,
            duracion_id: this.state.duracion_id,
            duracion: this.state.duracion_str,
            _isInvoice: this.state.is_factura,
            center: this.state.centro_id,
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession()
        };
        const callback = () => { this.handlePaymentCoworkConekta(params); }
        this.setState({ isPaying: true }, callback);
    }

    handleValidate = ({ name, isValid }) => {
        this.setState({
            fieldsValid: {
                ...this.state.fieldsValid,
                [name]: isValid
            }
        })
    }

    render() {
        const { t } = this.props;
        const servicios_incluidos = [
            { id: 13, name: 'Personal Assistant' },
            // { id: 14, name: 'Corporate Identity' },
        ]
        return (
            <React.Fragment>
                {this.state.success &&
                    <SuccessDialogPayment centerName={this.state.center_info.name} />
                }
                {
                    this.state.showModalInvalidNumber &&
                    <Dialog
                        title={t('venta_linea.modal.title_invalid_number')}
                        handleDismiss={() => this.setState({ showModalInvalidNumber: false })}
                    >
                        {t('venta_linea.modal.description_invalid_number')}
                    </Dialog>
                }
                <main className='content-resvations container-payment'>
                    <div className="container-resvations-title">
                        <GoBackButton isPayment ignoreModal />
                        <h2 className="page-header-card ">
                            <span>{t('dashboard.room_payment.heading_payment')}</span>
                        </h2>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 container-fluid-info-mas full-height">
                        <img
                            src={`https://api.iosoffices.com/apiosfera/v4/src/uploads/cowork_imagenes/${this.state.centro_id}`}
                            alt="Fondo de la imagen"
                            className="background-img"
                        />
                        <div className="panel-resvations container-forms flex-center">
                            <div className="card-info-card">
                                <h2 className="page-header-text">
                                    {this.state.center_info ? this.state.center_info.name : null}
                                </h2>
                                <p className="page-content-text">
                                    {this.state.center_info
                                        ? this.state.center_info.direccion + ", " + this.state.center_info.ciudad
                                        + ", " + this.state.center_info.estado + ", " + this.state.center_info.cp
                                        : null}
                                </p>
                                <div className="form-group">
                                    <div className="input-group input-lg-xl">
                                        <div className="form-group info-payment" style={{ color: "#fff" }}>
                                            <p>
                                                <Trans>dashboard.room_payment.period</Trans> {this.state.duracion_str ? this.state.duracion_str : null}
                                            </p>
                                            <p>
                                                <Trans>dashboard.room_payment.subtotal</Trans> {this.state.precio.toLocaleString('es-MX', {
                                                    style: 'currency', currency: 'MXN'
                                                })} MXN
                                            </p>
                                            <p>
                                                <Trans>dashboard.room_payment.iva</Trans> {(this.state.precio * .16).toLocaleString('es-MX', {
                                                    style: 'currency', currency: 'MXN'
                                                })} MXN
                                            </p>
                                            <p>
                                                <Trans>dashboard.room_payment.total</Trans>  {(this.state.precio * 1.16).toLocaleString('es-MX', {
                                                    style: 'currency', currency: 'MXN'
                                                })} MXN
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <h4 className="text-primary">
                                    <strong>{t('dashboard.reservations.heading_services')}</strong>
                                </h4>
                                <section className="flex-tags">
                                    {servicios_incluidos.map((service) =>
                                        <Tag
                                            variant
                                            iconSize="xl"
                                            key={service.id}
                                            id={service.id}
                                            text={service.name}
                                        />
                                    )}
                                </section>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 container-fluid-info-mas" >
                        <form method="post" onSubmit={this.handlePaymentSubmit}>
                            <fieldset>
                                <div className="panel-resvations container-forms">
                                    <div className="forms-card">
                                        <div className="col-xs-12">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    onChange={this.handleCardName}
                                                    placeholder={t('dashboard.room_payment.holder_cname')}
                                                    required={true}
                                                    type="text"
                                                    name="cardName"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.cardName} />
                                            </div>
                                        </div>
                                        <div className="col-xs-12">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    maxLength="19"
                                                    onChange={this.handleCardNumber}
                                                    placeholder={t('dashboard.room_payment.holder_cnumber')}
                                                    required
                                                    type="text"
                                                    name="cardNumber"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.cardNumber} />
                                                <TypeOfCard number={this.state.cardNumber} />
                                            </div>
                                        </div>
                                        <div className="col-xs-4">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    max="12"
                                                    min="1"
                                                    onChange={this.handleCardMonth}
                                                    placeholder={t('dashboard.room_payment.holder_cmonth')}
                                                    required={true}
                                                    type="number"
                                                    name="cardMonth"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.cmonth} />
                                            </div>
                                        </div>
                                        <div className="col-xs-4">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    max="99"
                                                    min="19"
                                                    onChange={this.handleCardYear}
                                                    placeholder={t('dashboard.room_payment.holder_cyear')}
                                                    required={true}
                                                    type="number"
                                                    name="cardYear"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.cyear} />
                                            </div>
                                        </div>
                                        <div className="col-xs-4">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    maxLength="4"
                                                    onChange={this.handleCardCvc}
                                                    placeholder={t('dashboard.room_payment.holder_cvc')}
                                                    required={true}
                                                    type="number"
                                                    name="cardCvc"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.cvc} />
                                            </div>
                                        </div>
                                        <div className="col-xs-12">
                                            <p>
                                                <small className="text-muted">
                                                    {t('dashboard.room_payment.security')}
                                                </small>
                                            </p>
                                        </div>
                                        <div className="col-xs-12">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    onChange={this.handleStreetChange}
                                                    placeholder={t('dashboard.room_payment.holder_street')}
                                                    required={true}
                                                    type="text"
                                                    name="street"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.street} />
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-8">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    onChange={this.handleNeighborhoodChange}
                                                    placeholder={t('dashboard.room_payment.holder_neighborhood')}
                                                    required={true}
                                                    type="text"
                                                    name="neighborhood"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.neighborhood} />
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-4">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    onChange={this.handlePoChange}
                                                    placeholder={t('dashboard.room_payment.holder_po')}
                                                    required={true}
                                                    type="number"
                                                    name="postalCode"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.postalCode} />
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-8">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    onChange={this.handleCityChange}
                                                    placeholder={t('dashboard.room_payment.holder_city')}
                                                    required={true}
                                                    type="text"
                                                    name="city"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.city} />
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-4">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    onChange={this.handleStateChange}
                                                    placeholder={t('dashboard.room_payment.holder_state')}
                                                    required={true}
                                                    type="text"
                                                    name="province"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.state} />
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-4">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    onChange={this.handleCountryChange}
                                                    placeholder={t('dashboard.room_payment.holder_country')}
                                                    required={true}
                                                    type="text"
                                                    name="country"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.country} />
                                            </div>
                                        </div>
                                        <div className="col-xs-12">
                                            <div className="form-group">
                                                <div className="checkbox">
                                                    <label>
                                                        <input
                                                            required={true}
                                                            type="checkbox"
                                                            value={this.state.is_accept_terms}
                                                            onChange={() => this.setState({ is_accept_terms: !this.state.is_accept_terms })}
                                                        />
                                                        {t('dashboard.room_payment.terms')}
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <div className="checkbox">
                                                    <label>
                                                        <input
                                                            onClick={this.handleFacturaChange}
                                                            type="checkbox" />
                                                        <Trans>venta_linea.payment.require_invoice</Trans>
                                                    </label>
                                                </div>
                                            </div>
                                            {this.state.is_factura ? (
                                                <aside className="alert alert-info" role='alert'>
                                                    <Trans>venta_linea.payment.invoice_advise</Trans>
                                                    <a
                                                        href='mailto:ventasenlinea@iosoffices.com'>
                                                        {" "} ventasenlinea@iosoffices.com
                                                    </a>
                                                </aside>
                                            ) : null}
                                        </div>
                                        <div className="col-xs-12">
                                            <div className={this.state.error ? "" : "hidden"}>
                                                <div className="alert alert-warning" role='alert'>
                                                    <i
                                                        className="glyphicon glyphicon-remove pull-right"
                                                        onClick={() => this.setState({ error: null })} />
                                                    {this.state.error}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xs-12">
                                            <div className="form-group">
                                                <button
                                                    className="btn btn-primary btn-full-width"
                                                    disabled={this.state.isPaying}
                                                    type="submit">
                                                    {t('dashboard.room_payment.btn_pay')}
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </main>
            </React.Fragment>
        )
    }
}

export default compose(
    translate('common'),
    withRouter
)(CardDomicilioConatiner);



// WEBPACK FOOTER //
// ./src/store/Domicilio/Payment/CardDomicilioConatiner.js